import { css, CSSResult } from 'lit'
import { csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'

export const cscProductImage = {
  backgroundColor: css`var(--csc-product-image-background-color, ${csColorBackground.secondary})`,
  heightDesktop: css`var(--csc-product-image-height-desktop, auto)`,
  heightMobile: css`var(--csc-product-image-height-mobile, auto)`,
  aspectRatio: css`var(--csc-product-image-aspect-ratio, auto)`,
}

export const style: CSSResult = css`
  :host {
    background-color: ${cscProductImage.backgroundColor};
    height: ${cscProductImage.heightMobile};
    width: 100%;

    @media(min-width: ${SCREENS.medium}) {
      height: ${cscProductImage.heightDesktop};
    }
  }

  cse-image {
    --cse-image-aspect-ratio: ${cscProductImage.aspectRatio};
  }

  cse-image.blend-multiply {
    mix-blend-mode: multiply;
  }
`
